import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from '../../../../../../components/DragHandle/DragHandle';
import { CategoryManagerRow, type CategoryManagerRowProps } from './CategoryManagerRow';

type SortableCategoryRowProps = Omit<CategoryManagerRowProps, 'reorderMode' | 'rowRef' | 'rowStyle' | 'dragHandle'>;

// Architectural summary: reorder-only wrapper; owns useSortable so normal mode mounts zero dnd.
const SortableCategoryRowComponent: React.FC<SortableCategoryRowProps> = (props) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: props.category.id,
  });
  const rowStyle: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : undefined,
  };
  const dragHandle = (
    <DragHandle
      dataTestId={`category-manager-drag-${props.category.id}`}
      disabled={props.isWriteInFlight}
      attributes={attributes}
      listeners={listeners}
      setActivatorNodeRef={setActivatorNodeRef}
    />
  );
  return <CategoryManagerRow {...props} reorderMode rowRef={setNodeRef} rowStyle={rowStyle} dragHandle={dragHandle} />;
};

export const SortableCategoryRow = React.memo(SortableCategoryRowComponent);
